import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import Pagination from "../common/Pagination";
import { FiEye } from "react-icons/fi";
import Swal from "sweetalert2";
import { BiEditAlt } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoEyeOutline, IoKeySharp } from "react-icons/io5";
import TemplateModal from "./TemplateModal";
import DeleteConfirmationDltModal from "./DeleteConfirmationDltModal";
import { toast } from "react-toastify";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import {isOperationRole} from "../../utils";

const Template = ({ openModal, customerCode, name }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize] = useState(10);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [modalType, setModalType] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const handleAuthKey = (temp) => {
    CustomAlert({
      title: "Template Key",
      text: temp.templateKey,
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleViewTemplate = (temp, type) => {
    setSelectedTemplate({
      name: temp?.templateName,
      id: temp?.sendorId,
      tempId: temp?.templateId,
      type: temp?.templateType,
      customerCode: temp?.customerCode,
      customerName: temp?.customerName,
      entityId: temp?.entityId,
      smsContent: temp?.smsContent,
      smsDesc: temp?.smsDesc,
    });
    setModalType(type);
    setOpenPopup(true);
  };

  const handleClose = () => {
    setOpenPopup(false);
    setOpenDeleteModal(false);
  };

  const handleShowTable = async () => {
    setShowTable(true);
    setLoading(true);
    await fetchTemplateData(1);
  };

  const fetchTemplateData = async (page) => {
    const data = {
      username: loggedInUserName,
      customerCode: customerCode,
    };

    try {
      const response = await axiosPostApi(
        `${apiList.DLT_FETCH_TEMPLATE}?pageSize=${pageSize}&pageNo=${page}`,
        data
      );
      setTemplate(response?.data?.data || []);
      setPageDetails(response?.data?.pageDetails || null);
    } catch (error) {
      console.error("Failed to fetch template data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    openModal();
    setShowTable(false);
  };

  const showFullContent = (content) => {
    Swal.fire({
      title: "Full Content",
      text: content,
      confirmButtonText: "Close",
    });
  };

  const handleShowFullDescription = (description) => {
    Swal.fire({
      title: "Full Description",
      text: description,
      confirmButtonText: "Close",
    });
  };

  const handleDeleteId = (temp) => {
    setDeletedId({
      username: loggedInUserName,
      customerCode: temp?.customerCode,
      templateId: temp?.templateId,
      status: "3",
    });
    setOpenDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.DELETE_TEMPLATEID, deletedId);
      if (response?.status === 200 && response.data.status === true) {
        toast.success("Template Deleted Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose();
        await handleShowTable();
      } else if (response.data.respCode === "01") {
        CustomAlert({
          title: "Data Submission Error",
          text: response.data.message || "Please check the details and try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        handleClose();
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while deleting the template. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const getActionItems = (temp) => {
    const actions = [];

    if (!isOperationRole()) {
      actions.push({
        icon: <BiEditAlt style={{ marginRight: "10px" }} />,
        label: "Edit",
        onClick: (e) => {
          e.stopPropagation();
          handleViewTemplate(temp, "modify");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleViewTemplate(temp, "view");
      },
    });

    if (!isOperationRole()) {
      actions.push({
        icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
        label: "Delete",
        onClick: (e) => {
          e.stopPropagation();
          handleDeleteId(temp);
        },
      });
    }

    actions.push({
      icon: <IoKeySharp style={{ marginRight: "10px" }} />,
      label: "Template Key",
      onClick: (e) => {
        e.stopPropagation();
        handleAuthKey(temp);
      },
    });

    return actions;
  };

  return (
    <div className="template-container">
      <div className="d-flex first-tab-controls">
        <div className="d-flex gap-3"></div>
        <div className="d-flex gap-3">
          <button
            className="btn addUser"
            onClick={handleShowTable}
            disabled={showTable}
            style={{
              backgroundColor: showTable ? "#80d7e1" : "",
              color: showTable ? "#ffffff" : "",
            }}
          >
            Show Template ID
          </button>
          {!isOperationRole() && (
            <button className="btn addUser" onClick={handleSwitch}>
              + Add Template ID
            </button>
          )}
        </div>
      </div>
      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        showTable && (
          <div className="table-container">
            {template.length > 0 ? (
              <>
                <div className="table-wrapper">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Status</th>
                        <th>Template Name</th>
                        <th>Sender ID</th>
                        <th>Entity ID</th>
                        <th>Template ID</th>
                        <th>Content</th>
                        <th>Added On</th>
                        <th>Type</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      {template.map((temp) => (
                        <tr key={temp.templateId}>
                          <td className="actions" style={{ overflow: "visible" }}>
                            <Popover>
                              {({ open, close }) => (
                                <>
                                  <Popover.Button
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      display: "inline-block",
                                      padding: "0 10px",
                                      background: "none",
                                      border: "none",
                                    }}
                                  >
                                    ⋮
                                  </Popover.Button>
                                  <Transition
                                    as={React.Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                  >
                                    <Popover.Panel
                                      style={{
                                        position: "absolute",
                                        zIndex: 2000,
                                        minWidth: "220px",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "8px",
                                        padding: "8px 0",
                                        overflow: "visible",
                                      }}
                                    >
                                      {getActionItems(temp).map((action, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 20px",
                                            cursor: "pointer",
                                            color: "#333",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            transition: "background-color 0.2s",
                                            whiteSpace: "nowrap",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#f0f0f0")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#ffffff")
                                          }
                                          onClick={(e) => {
                                            action.onClick(e);
                                            close();
                                          }}
                                        >
                                          {action.icon}
                                          <span>{action.label}</span>
                                        </div>
                                      ))}
                                    </Popover.Panel>
                                  </Transition>
                                </>
                              )}
                            </Popover>
                          </td>
                          <td>
                            <span
                              className="status"
                              style={{
                                color:
                                  temp.status === "ACTIVE"
                                    ? "#55cd69"
                                    : temp.status === "BLOCKED"
                                    ? "#fb4a3f"
                                    : "#6c757d",
                              }}
                            >
                              {temp.status || "-"}
                            </span>
                          </td>
                          <td>{temp.templateName || "-"}</td>
                          <td>{temp.sendorId || "-"}</td>
                          <td>{temp.entityId || "-"}</td>
                          <td>{temp.templateId || "-"}</td>
                          <td>
                            {temp.smsContent ? (
                              <>
                                {temp.smsContent.substring(0, 10)}...
                                <FiEye
                                  className="view-icon"
                                  onClick={() => showFullContent(temp.smsContent)}
                                  style={{ cursor: "pointer", marginLeft: "8px" }}
                                  title="View full content"
                                />
                              </>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{temp.createdDate || "-"}</td>
                          <td>{temp.templateType || "-"}</td>
                          <td>
                            {temp.smsDesc ? (
                              temp.smsDesc.length > 10 ? (
                                <>
                                  {temp.smsDesc.slice(0, 10)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() => handleShowFullDescription(temp.smsDesc)}
                                    style={{ cursor: "pointer", marginLeft: "8px" }}
                                    title="View full Description"
                                  />
                                </>
                              ) : (
                                temp.smsDesc
                              )
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    totalCount={pageDetails?.totalRecords || 0}
                    pageSize={pageSize}
                    onPageChange={(page) => {
                      setCurrentPage(page);
                      fetchTemplateData(page);
                    }}
                  />
                </div>
              </>
            ) : (
              <p className="no-data-message">No data available</p>
            )}
          </div>
        )
      )}
      <TemplateModal
        show={openPopup}
        handleClose={handleClose}
        customerCode={customerCode}
        name={name}
        TempDetails={selectedTemplate}
        modalType={modalType}
        handleShowTable={handleShowTable}
      />
      <DeleteConfirmationDltModal
        isOpen={openDeleteModal}
        onClose={handleClose}
        handleDelete={handleDelete}
        loading={loading}
      />
    </div>
  );
};

export default Template;